import { QUERIES } from '@repo/ui/queries';
import styled from 'styled-components';

import { FlexColumn } from 'styles/layouts';

export const ImageWrapper = styled(FlexColumn)`
  align-items: center;
  justify-content: center;

  width: 100%;

  aspect-ratio: 1 / 1;
  overflow: hidden;
  touch-action: none;

  ${QUERIES.largeTabletAndUp} {
    width: 384px;
  }
`;
